var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3218_1215)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.005 0C11.9838 0 13.9182 0.586783 15.5635 1.68615C17.2088 2.78551 18.4912 4.34808 19.2484 6.17625C20.0057 8.00443 20.2038 10.0161 19.8178 11.9569C19.4317 13.8977 18.4788 15.6804 17.0796 17.0796C15.6804 18.4788 13.8977 19.4317 11.9569 19.8178C10.0161 20.2038 8.00443 20.0057 6.17625 19.2484C4.34808 18.4912 2.78551 17.2088 1.68615 15.5635C0.586783 13.9182 0 11.9838 0 10.005C0 7.35151 1.0541 4.8067 2.9304 2.9304C4.8067 1.0541 7.35151 0 10.005 0V0ZM3.89195 14.7874L14.7874 3.89195C13.4288 2.81468 11.7386 2.24187 10.005 2.27114C8.98827 2.26717 7.9808 2.4645 7.04069 2.85176C6.10058 3.23901 5.24643 3.80854 4.52748 4.52748C3.80854 5.24643 3.23901 6.10058 2.85176 7.04069C2.4645 7.9808 2.26717 8.98827 2.27114 10.005C2.24187 11.7386 2.81468 13.4288 3.89195 14.7874ZM16.2081 5.21261L5.2026 16.2181C6.60143 17.2314 8.27795 17.7903 10.005 17.8189C11.0315 17.8202 12.0482 17.619 12.9968 17.2268C13.9454 16.8346 14.8074 16.2591 15.5332 15.5332C16.2591 14.8074 16.8346 13.9454 17.2268 12.9968C17.619 12.0482 17.8202 11.0315 17.8189 10.005C17.7853 8.28029 17.223 6.60747 16.2081 5.21261Z",
    fill: "#FD2B55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3218_1215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/CancelIcon.4981ffe30990635b7d6516b8933d8a94.svg";
export { ForwardRef as ReactComponent };